import React from 'react'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'
import * as firebase from '../../helpers/firebase'
import './LoginScreen.scss'

// Display user avatar initial for returning users
// Uses Google sign in to Authenticate users
function LoginScreen(props) {
    const avatarImage = props.lastLoggedInUser && props.lastLoggedInUser.photoURL ? props.lastLoggedInUser.photoURL : '/images/gecko.jpg'

    const firebaseAuthUiConfig = {
        signInFlow: 'popup',
        signInOptions: [
            firebase.GOOGLE_PROVIDER,
            //firebase.FACEBOOK_PROVIDER
        ],
        signInSuccessUrl: '/',
        callbacks: {
            signInSuccessWithAuthResult: handleUserLogin
        }
    }

    const introStyle = ({
        position: "relative",
        top: 5 + 'vh',
        fontSize: 36 + "px",
        color: "white",
    })
    const appTitleStyle = ({
        fontSize: 50 + "px"
        
    })
    
    function handleUserLogin(authResult) {
        props.onUserLoggedIn({ ...authResult.user, isNewUser: authResult.additionalUserInfo.isNewUser })

        // do not redirect
        return false
    }

    return (
        <div className='sign-in-screen'>
        <div id='header-bar'></div>
        <img id='bg-image' src='/images/leaves.jpg'/>
            <div className='header container-fluid'>
                <div className="row w-100 mt-5">
                        <h1 id='gecko' className='col-12 position-relative' style={appTitleStyle}><span className='g'>G</span>ecko Notes</h1>
                </div>
            </div>

            <main>
                <div className='col-12 mt-5 mx-auto d-flex justify-content-center'>
                    <span className='headline' style={introStyle}>Let's get started</span>
                </div>
                <div className='login-box'>
                    <div className='top'>
                        <img className='avatar' src={avatarImage} alt='Gecko Avatar' />
                        { props.lastLoggedInUser && <span className='name'>{props.lastLoggedInUser.displayName}</span> }
                    </div>
                    <StyledFirebaseAuth uiConfig={firebaseAuthUiConfig} firebaseAuth={firebase.getAuth()} />
                </div>
            </main>
        </div>
    )
}

export default LoginScreen